module.exports = __webpack_public_path__ + "static/img/icon_pro5s.d13d1fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/index/icon_pro5s.png
// module id = W/4E
// module chunks = 11